// extracted by mini-css-extract-plugin
module.exports = {"tab":"_tab_tab__pBgc8","tabIsActive":"_tab_tabIsActive__MCGX1"};